import {
  Button,
  TextField,
  MenuItem,
  Box,
  DialogActions,
  DialogContent,
  Stack,
  FormControlLabel,
  Switch,
  DialogTitle,
} from "@mui/material";
import { useFormik } from "formik";
import * as yup from "yup";
import { prettify, renderDeviceName } from "../../../utils/utils";
import { useNewDevice, devices } from "..";
import { useGetPatients } from "../../PatientComponents";

const validationSchema = yup.object({
  name: yup.string("Dispositivo"),
  device_type: yup.number(), //.min(1).max(4),
  is_installed: yup.boolean("Installato"),
  is_online: yup.boolean("Online"),
  serial_number: yup.string("Numero seriale"),
  note: yup.string("Note"),
  // patient_id: yup,
});

function AddDevice({ closeModal }) {
  // === web service queries/mutations ===
  const newDeviceMutation = useNewDevice(closeModal);
  const patientsQuery = useGetPatients();

  // === Form handling ===
  const formik = useFormik({
    initialValues: {
      name: "",
      device_type: null,
      is_installed: false,
      is_online: false,
      serial_number: "",
      note: "",
      patient_id: null,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      newDeviceMutation.mutate({ ...values });
    },
  });

  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <DialogTitle>Nuovo dispositivo</DialogTitle>
        <DialogContent>
          <Stack direction="row" spacing={8} sx={{ width: "100%" }}>
            <Box sx={{ float: "left", width: "50%" }}>
              <TextField
                autoFocus
                margin="dense"
                fullWidth
                id="name"
                name="name"
                label="Dispositivo"
                type="text"
                variant="standard"
                onChange={formik.handleChange}
                value={formik.values.name}
                error={formik.touched.name && Boolean(formik.errors.name)}
                helperText={formik.touched.name && formik.errors.name}
              />

              <TextField
                autoFocus
                select
                margin="dense"
                fullWidth
                id="device_type"
                name="device_type"
                label="Tipo di dispositivo"
                type="text"
                variant="standard"
                onChange={formik.handleChange}
                value={formik.values.device_type}
                error={
                  formik.touched.device_type &&
                  Boolean(formik.errors.device_type)
                }
                helperText={
                  formik.touched.device_type && formik.errors.device_type
                }
              >
                {devices.map((option) => (
                  <MenuItem key={option.device_type} value={option.device_type}>
                    {renderDeviceName(option.device_type)}
                  </MenuItem>
                ))}
              </TextField>

              <TextField
                autoFocus
                select
                margin="dense"
                fullWidth
                id="patient_id"
                name="patient_id"
                label="Paziente"
                type="text"
                variant="standard"
                onChange={formik.handleChange}
                value={formik.values.patient_id}
                error={
                  formik.touched.patient_id && Boolean(formik.errors.patient_id)
                }
                helperText={
                  formik.touched.patient_id && formik.errors.patient_id
                }
              >
                {patientsQuery.data.patients.map((option) => (
                  <MenuItem key={option.id} value={option.id}>
                    {`${option.first_name} ${option.last_name}`}
                  </MenuItem>
                ))}
              </TextField>

              <TextField
                autoFocus
                margin="dense"
                fullWidth
                id="serial_number"
                name="serial_number"
                label="Numero Seriale / Mac Address"
                type="text"
                variant="standard"
                onChange={formik.handleChange}
                value={formik.values.serial_number}
                error={
                  formik.touched.serial_number &&
                  Boolean(formik.errors.serial_number)
                }
                helperText={
                  formik.touched.serial_number && formik.errors.serial_number
                }
              />
            </Box>

            <Box sx={{ float: "right", width: "50%" }}>
              <FormControlLabel
                control={
                  <Switch
                    name="is_installed"
                    value={formik.values.is_installed}
                    checked={formik.values.is_installed}
                    onChange={formik.handleChange}
                  />
                }
                label="Installato"
                labelPlacement="start"
              />
              <FormControlLabel
                control={
                  <Switch
                    name="is_online"
                    value={formik.values.is_online}
                    checked={formik.values.is_online}
                    onChange={formik.handleChange}
                  />
                }
                label="Online"
                labelPlacement="start"
              />

              <TextField
                margin="dense"
                fullWidth
                id="note"
                name="note"
                label="Note"
                multiline
                minRows={4}
                type="text"
                variant="standard"
                onChange={formik.handleChange}
                value={formik.values.note}
              />
            </Box>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button disabled={newDeviceMutation.isLoading} type="submit">
            Conferma
          </Button>
          <Button
            disabled={newDeviceMutation.isLoading}
            onClick={formik.handleReset}
          >
            Reset
          </Button>
          <Button
            disabled={newDeviceMutation.isLoading}
            color="error"
            onClick={closeModal}
          >
            Annulla
          </Button>
        </DialogActions>
      </form>
    </>
  );
}

export default AddDevice;
